
import React from 'react'
import { useTranslation } from 'react-i18next'
import "./protection.scss"

function Protection() {
  const { t } = useTranslation()
  return (
    <div className='container-protection'>
      <div className='texts-protection'>
        <h1>{t("user_security_and_management.protection.title")}</h1>
        <p>{t("user_security_and_management.protection.section_text_1")}</p>
        <p>{t("user_security_and_management.protection.section_text_2")}</p>
        <p>{t("user_security_and_management.protection.section_text_3")}</p>
      </div>
    </div>
  )
}

export default Protection